import React, { Component } from 'react';
import {Modal} from 'react-bootstrap';
import Cart from './cart';

class CartModal extends Component {

    render () {
        return (
            <Modal dialogClassName='modal-lg' show={this.props.show} onHide={this.props.onHide}>
                <Modal.Header closeButton>
                    <Modal.Title>Your Cart</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Cart cart={this.props.cart} currency={this.props.currency} />
                </Modal.Body>
                <Modal.Footer>
                    {this.props.cart && <button className='btn btn-primary' onClick={this.props.checkout}>Checkout</button>}
                    <button className='btn btn-secondary' onClick={this.props.onHide}>Shop More</button>
                </Modal.Footer>
            </Modal>
        )

    }
}

export default CartModal;
